module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/admincentro-escolar-informacion/admincentro-escolar-informacion.component.scss
// module id = ./src/app/admincentro-escolar-informacion/admincentro-escolar-informacion.component.scss
// module chunks = main